import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getSubmissions } from 'app/entities/submission/submission.reducer';
import { createEntity, getEntity, reset, updateEntity } from './submission-request.reducer';

export const SubmissionRequestUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const submissions = useAppSelector(state => state.submission.entities);
  const submissionRequestEntity = useAppSelector(state => state.submissionRequest.entity);
  const loading = useAppSelector(state => state.submissionRequest.loading);
  const updating = useAppSelector(state => state.submissionRequest.updating);
  const updateSuccess = useAppSelector(state => state.submissionRequest.updateSuccess);

  const handleClose = () => {
    navigate(`/submission-request${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getSubmissions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...submissionRequestEntity,
      ...values,
      submission: submissions.find(it => it.id.toString() === values.submission?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...submissionRequestEntity,
          submission: submissionRequestEntity?.submission?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tycheApp.submissionRequest.home.createOrEditLabel" data-cy="SubmissionRequestCreateUpdateHeading">
            <Translate contentKey="tycheApp.submissionRequest.home.createOrEditLabel">Create or edit a SubmissionRequest</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="submission-request-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tycheApp.submissionRequest.requestJson')}
                id="submission-request-requestJson"
                name="requestJson"
                data-cy="requestJson"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.submissionRequest.type')}
                id="submission-request-type"
                name="type"
                data-cy="type"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.submissionRequest.ocrJson')}
                id="submission-request-ocrJson"
                name="ocrJson"
                data-cy="ocrJson"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.submissionRequest.responseJson')}
                id="submission-request-responseJson"
                name="responseJson"
                data-cy="responseJson"
                type="text"
              />
              <ValidatedField
                id="submission-request-submission"
                name="submission"
                data-cy="submission"
                label={translate('tycheApp.submissionRequest.submission')}
                type="select"
              >
                <option value="" key="0" />
                {submissions
                  ? submissions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/submission-request" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SubmissionRequestUpdate;
